import { render, staticRenderFns } from "./EventsSliderItem.vue?vue&type=template&id=f639ffec&scoped=true&"
import script from "./EventsSliderItem.vue?vue&type=script&lang=js&"
export * from "./EventsSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./EventsSliderItem.vue?vue&type=style&index=0&id=f639ffec&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f639ffec",
  null
  
)

export default component.exports